(function () {
  'use strict';

  var doc = document;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var $  = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };

  /* ------------------------------------------------------------------ *
   * Scroll lock (shared by every overlay)
   * ------------------------------------------------------------------ */
  var lockCount = 0;
  function lockScroll(on) {
    lockCount = Math.max(0, lockCount + (on ? 1 : -1));
    doc.body.style.overflow = lockCount ? 'hidden' : '';
  }

  /* ------------------------------------------------------------------ *
   * Overlay drawers: mobile menu, mobile filters
   * ------------------------------------------------------------------ */
  function initDrawers() {
    $$('[data-drawer]').forEach(function (drawer) {
      var id = drawer.getAttribute('data-drawer');
      var lastFocus = null;

      function open() {
        lastFocus = doc.activeElement;
        drawer.classList.add('is-open');
        drawer.removeAttribute('aria-hidden');
        lockScroll(true);
        var first = $('button, a[href], input, select, textarea', drawer);
        if (first) first.focus();
      }
      function close() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        lockScroll(false);
        if (lastFocus) lastFocus.focus();
      }

      $$('[data-open="' + id + '"]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); open(); });
      });
      $$('[data-close]', drawer).forEach(function (b) {
        b.addEventListener('click', close);
      });
      var scrim = $('.drawer__scrim', drawer);
      if (scrim) scrim.addEventListener('click', close);
      drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); return; }
        if (e.key !== 'Tab') return;
        var f = $$('button, a[href], input:not([type=hidden]), select, textarea', drawer)
          .filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * Header shadow on scroll
   * ------------------------------------------------------------------ */
  function initHeader() {
    var hdr = $('[data-header]');
    if (!hdr) return;
    var onScroll = function () {
      hdr.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ------------------------------------------------------------------ *
   * Hero slideshow
   * ------------------------------------------------------------------ */
  function initHero() {
    $$('[data-hero]').forEach(function (root) {
      var slides = $$('[data-slide]', root);
      var dots = $$('[data-dot]', root);
      if (slides.length < 2) return;

      var index = 0, timer, onscreen = true, paused = false;

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === index);
          d.setAttribute('aria-selected', n === index ? 'true' : 'false');
        });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        stop();
        if (reduced.matches || paused || doc.hidden || !onscreen) return;
        timer = setInterval(function () { show(index + 1); }, 6500);
      }
      function sync() { if (reduced.matches || paused) { stop(); } else { start(); } }

      dots.forEach(function (d, n) {
        d.addEventListener('click', function () { show(n); start(); });
      });

      var io = new IntersectionObserver(function (entries) {
        onscreen = entries[0].isIntersecting;
        onscreen ? start() : stop();
      }, { threshold: 0.15 });
      io.observe(root);

      root.addEventListener('pointerenter', function () { paused = true; stop(); });
      root.addEventListener('pointerleave', function () { paused = false; sync(); });
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', sync);
      doc.addEventListener('visibilitychange', function () { doc.hidden ? stop() : sync(); });

      if (reduced.addEventListener) reduced.addEventListener('change', sync);
      show(0);
      start();
    });
  }

  /* ------------------------------------------------------------------ *
   * Seamless marquee: duplicate track content once
   * ------------------------------------------------------------------ */
  function initMarquee() {
    $$('[data-marquee]').forEach(function (track) {
      if (track.getAttribute('data-ready')) return;
      track.innerHTML += track.innerHTML;
      track.setAttribute('data-ready', '1');
    });
  }

  /* ------------------------------------------------------------------ *
   * Quantity steppers
   * ------------------------------------------------------------------ */
  function initQty() {
    $$('[data-qty]').forEach(function (box) {
      var input = $('input', box);
      if (!input) return;
      $$('button[data-step]', box).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-step'), 10) || 0;
          var min = parseInt(input.getAttribute('min') || '0', 10);
          var max = parseInt(input.getAttribute('max') || '999999', 10);
          var next = (parseInt(input.value, 10) || 0) + step;
          input.value = Math.min(max, Math.max(min, next));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    /* line-item quantity changes submit the cart form once, debounced */
    $$('[data-qty][data-auto-submit] input').forEach(function (input) {
      var t;
      input.addEventListener('change', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var form = input.closest('form');
          if (!form) return;
          var btn = form.querySelector('[name="update"]');
          if (btn) btn.click(); else form.submit();
        }, 500);
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * Product variant selection
   * ------------------------------------------------------------------ */
  function initProduct() {
    var root = $('[data-product]');
    if (!root) return;

    /* The JSON can sit inside the section or, in older builds, after it — a scoped-only
       lookup silently killed every listener on the page, so fall back to the document. */
    var dataEl = $('[data-variants]', root) || $('[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput   = $('[data-variant-id]', root);
    var priceEl   = $('[data-price]', root);
    var wasEl     = $('[data-price-was]', root);
    var offEl     = $('[data-price-off]', root);
    var stockEl   = $('[data-stock]', root);
    var skuEl     = $('[data-sku]', root);
    var submitBtns = $$('[data-submit]', root);
    var selects   = $$('[data-option-index]', root);
    var groups    = $$('[data-option-group]', root);
    var stageImg  = $('[data-stage-img]', root);

    function selectedOptions() {
      var out = [];
      selects.forEach(function (s) {
        out[parseInt(s.getAttribute('data-option-index'), 10)] = s.value;
      });
      /* button groups take precedence when present */
      groups.forEach(function (g) {
        var on = $('button.is-active', g);
        if (on) out[parseInt(g.getAttribute('data-option-group'), 10)] = on.getAttribute('data-value');
      });
      return out;
    }

    function findVariant(opts) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }

    function render(v) {
      if (!v) {
        submitBtns.forEach(function (b) { b.disabled = true; });
        if (stockEl) { stockEl.className = 'pd__stock pd__stock--out'; stockEl.textContent = 'Unavailable in this combination'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (wasEl) {
        if (v.compare_at && v.compare_at !== v.price) {
          wasEl.textContent = v.compare_at;
          wasEl.style.display = '';
        } else { wasEl.textContent = ''; wasEl.style.display = 'none'; }
      }
      if (offEl) {
        if (v.off) { offEl.textContent = v.off; offEl.style.display = ''; }
        else { offEl.textContent = ''; offEl.style.display = 'none'; }
      }
      if (skuEl && v.sku) skuEl.textContent = v.sku;
      if (stockEl) {
        stockEl.className = 'pd__stock pd__stock--' + (v.available ? (v.low ? 'low' : 'in') : 'out');
        stockEl.textContent = v.available ? (v.low ? 'Low stock — order soon' : 'In stock — ready to ship') : 'Out of stock';
      }
      submitBtns.forEach(function (b) {
        b.disabled = !v.available;
        var label = b.querySelector('[data-label-add]');
        if (label && label.hasAttribute('data-label-add')) {
          label.textContent = v.available ? label.getAttribute('data-label-add') : 'Sold out';
        }
      });
      if (stageImg && v.image) {
        stageImg.src = v.image;
        var thumb = $('[data-thumb][data-media-id="' + v.featured_media + '"]', root);
        if (thumb) selectThumb(thumb);
      }
      var stickyPrice = $('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = v.price;
    }

    function sync() { render(findVariant(selectedOptions())); }

    selects.forEach(function (s) { s.addEventListener('change', sync); });

    groups.forEach(function (g) {
      var idx = parseInt(g.getAttribute('data-option-group'), 10);
      $$('button', g).forEach(function (btn) {
        if (btn.disabled) return;
        btn.addEventListener('click', function () {
          $$('button', g).forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var sel = selects.filter(function (s) {
            return parseInt(s.getAttribute('data-option-index'), 10) === idx;
          })[0];
          if (sel) sel.value = btn.getAttribute('data-value');
          sync();
        });
      });
    });

    /* ---------------------------------------------------------------- *
     * Gallery: thumbnail strip + full-size viewer
     * ---------------------------------------------------------------- */
    var thumbs = $$('[data-thumb]', root);
    var current = 0;
    var lb = $('[data-lightbox]', root);
    var lbImg = $('[data-lb-img]', root);
    var lbCount = $('[data-lb-count]', root);
    var lastFocus = null;

    function thumbImage(i) { return thumbs[i] ? $('img', thumbs[i]) : null; }

    function selectThumb(thumb) {
      var idx = thumbs.indexOf(thumb);
      if (idx > -1) current = idx;
      thumbs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-pressed', 'true');

      var img = $('img', thumb);
      if (stageImg && img) {
        /* the strip carries two URLs: a 1200 for the stage, the original for the viewer */
        stageImg.src = img.getAttribute('data-stage-src') || img.getAttribute('data-full') || img.src;
        if (img.getAttribute('alt')) stageImg.alt = img.getAttribute('alt');
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { selectThumb(thumb); });
    });

    function showImage(i) {
      if (!thumbs.length) return;
      var next = (i + thumbs.length) % thumbs.length;
      selectThumb(thumbs[next]);
      var img = thumbImage(next);
      if (lbImg && img) {
        lbImg.src = img.getAttribute('data-full') || img.src;
        lbImg.alt = img.getAttribute('alt') || '';
      }
      if (lbCount) lbCount.textContent = (next + 1) + ' / ' + thumbs.length;
    }

    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); closeLightbox(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); showImage(current + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); showImage(current - 1); }
    }

    function openLightbox() {
      if (!lb || !thumbs.length) return;
      lastFocus = doc.activeElement;
      showImage(current);
      lb.hidden = false;
      /* flush the hidden -> shown change so the opacity transition actually runs;
         rAF is not reliable enough here (headless/preview contexts skip frames) */
      void lb.offsetWidth;
      lb.classList.add('is-open');
      lockScroll(true);
      var closeBtn = $('[data-lb-close]', lb);
      if (closeBtn) closeBtn.focus();
      doc.addEventListener('keydown', onKey);
    }

    function closeLightbox() {
      if (!lb || lb.hidden) return;
      lb.classList.remove('is-open');
      lb.hidden = true;
      lockScroll(false);
      doc.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    var stage = $('[data-stage]', root);
    if (stage) stage.addEventListener('click', openLightbox);

    if (lb) {
      var lbClose = $('[data-lb-close]', lb);
      var lbPrev = $('[data-lb-prev]', lb);
      var lbNext = $('[data-lb-next]', lb);
      if (lbClose) lbClose.addEventListener('click', closeLightbox);
      if (lbPrev) lbPrev.addEventListener('click', function () { showImage(current - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { showImage(current + 1); });
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target.classList.contains('lb__figure')) closeLightbox();
      });

      /* swipe on touch devices */
      var tx = 0;
      lb.addEventListener('touchstart', function (e) { tx = e.changedTouches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - tx;
        if (Math.abs(dx) > 45) showImage(current + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    /* sticky buy bar on mobile */
    var sticky = $('[data-stickybuy]');
    var buyBlock = $('[data-buyblock]');
    if (sticky && buyBlock && 'IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        sticky.classList.toggle('is-on', !visible);
      }, { threshold: 0 });
      sio.observe(buyBlock);
    }

    sync();
  }

  /* ------------------------------------------------------------------ *
   * Tabs
   * ------------------------------------------------------------------ */
  function initTabs() {
    $$('[data-tabs]').forEach(function (root) {
      var btns = $$('[data-tab]', root);
      var panels = $$('[data-panel]', root);
      btns.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
          if (panels[i]) panels[i].classList.add('is-active');
        });
        btn.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!dir) return;
          e.preventDefault();
          var next = btns[(i + dir + btns.length) % btns.length];
          next.focus(); next.click();
        });
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * FAQ accordion
   * ------------------------------------------------------------------ */
  function initFaq() {
    $$('[data-faq]').forEach(function (item) {
      var btn = $('.faqitem__q', item);
      if (!btn) return;
      btn.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * Facets: collapsing groups + auto-apply
   * ------------------------------------------------------------------ */
  function initFacets() {
    $$('[data-facet]').forEach(function (f) {
      var head = $('.facet__head', f);
      if (!head) return;
      head.setAttribute('aria-expanded', f.classList.contains('is-collapsed') ? 'false' : 'true');
      head.addEventListener('click', function () {
        var collapsed = f.classList.toggle('is-collapsed');
        head.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      });
    });

    var form = $('[data-facets-form]');
    if (form) {
      $$('input[type="checkbox"]', form).forEach(function (cb) {
        cb.addEventListener('change', function () { form.submit(); });
      });
    }
  }

  /* ------------------------------------------------------------------ *
   * Recently viewed (product page + optional rail)
   * ------------------------------------------------------------------ */
  function rememberProduct(p) {
    try {
      var list = JSON.parse(localStorage.getItem('ap_recent') || '[]');
      list = list.filter(function (x) { return x.handle !== p.handle; });
      list.unshift(p);
      localStorage.setItem('ap_recent', JSON.stringify(list.slice(0, 8)));
    } catch (e) {}
  }
  function renderRecent() {
    var host = $('[data-recent]');
    if (!host) return;
    var list;
    try { list = JSON.parse(localStorage.getItem('ap_recent') || '[]'); } catch (e) { list = []; }
    var current = host.getAttribute('data-current');
    list = list.filter(function (x) { return x.handle !== current; }).slice(0, 4);
    if (!list.length) { var sec = host.closest('section'); if (sec) sec.remove(); return; }
    host.innerHTML = list.map(function (p) {
      return '<a class="pcard" href="' + p.url + '">' +
        '<div class="pcard__media"><img src="' + p.img + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy" width="300" height="300"></div>' +
        '<div class="pcard__body"><div class="pcard__title">' + p.title + '</div>' +
        '<div class="pcard__foot"><span class="price__now">' + p.price + '</span></div></div></a>';
    }).join('');
  }

  /* ------------------------------------------------------------------ *
   * Fitment finder: make -> model cascade
   * ------------------------------------------------------------------ */
  function initFitment() {
    var form = $('.fit__form');
    if (!form) return;
    var makeSel = $('#fit-make', form);
    var modelSel = $('#fit-model', form);
    var yearSel = $('#fit-year', form);
    var dataEl = $('[data-fit-models]');
    if (!makeSel || !modelSel) return;

    var map = {};
    var raw = '';
    if (dataEl) {
      try { raw = JSON.parse(dataEl.textContent); } catch (e) { raw = ''; }
    }
    String(raw || '').split(String.fromCharCode(10)).forEach(function (line) {
      var i = line.indexOf(':');
      if (i < 1) return;
      var make = line.slice(0, i).trim().toLowerCase();
      var models = line.slice(i + 1).split(',').map(function (m) { return m.trim(); })
        .filter(function (m) { return !!m; });
      if (make && models.length) map[make] = models;
    });

    function fillModels() {
      var list = map[(makeSel.value || '').toLowerCase()] || [];
      modelSel.innerHTML = '';
      var ph = doc.createElement('option');
      ph.value = '';
      ph.textContent = list.length ? 'Select model' : (makeSel.value ? 'Any model' : 'Select make first');
      modelSel.appendChild(ph);
      list.forEach(function (m) {
        var o = doc.createElement('option');
        o.value = m;
        o.textContent = m;
        modelSel.appendChild(o);
      });
      modelSel.disabled = !list.length;
    }

    makeSel.addEventListener('change', fillModels);
    fillModels();

    /* The search box understands a single query string, so fold the three
       selects into it on submit; without JS the year still posts on its own. */
    form.addEventListener('submit', function () {
      /* Shopify search ANDs every token, so the year is left out of the query: titles
         carry ranges like "2019-2024" and a bare "2021" would zero the results. The year
         only drives the query when nothing else is chosen. FITMENT_QUERY_V2 */
      var parts = [];
      if (makeSel.value) parts.push(makeSel.value);
      if (modelSel.value) parts.push(modelSel.value);
      if (!parts.length && yearSel && yearSel.value) parts.push(yearSel.value);
      if (!parts.length) return;

      /* A <select> silently discards values that are not one of its options, so the
         combined query goes into a hidden input and the year select gives up its name
         to avoid posting ?q= twice. */
      var hidden = form.querySelector('input[data-fit-q]');
      if (!hidden) {
        hidden = doc.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'q';
        hidden.setAttribute('data-fit-q', '');
        form.appendChild(hidden);
      }
      hidden.value = parts.join(' ');
      if (yearSel) yearSel.removeAttribute('name');
    });
  }

  /* ------------------------------------------------------------------ *
   * Newsletter / generic form feedback
   * ------------------------------------------------------------------ */
  function initForms() {
    $$('form[data-ajax]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var btn = $('button[type="submit"]', form);
        if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * Boot
   * ------------------------------------------------------------------ */
  function boot() {
    initDrawers();
    initHeader();
    initHero();
    initMarquee();
    initQty();
    initProduct();
    initTabs();
    initFaq();
    initFacets();
    initForms();
    initFitment();
    renderRecent();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.AutoParts = {
    rememberProduct: rememberProduct,
    renderRecent: renderRecent
  };
})();
